import React from 'react';
import { motion } from 'framer-motion';
import { Minus } from 'lucide-react';
import { Button, Section } from './Shared';
import { scrollToId } from '../lib/checkout';
export function Hero() {
  return <section className="relative pt-8 pb-10 md:pt-16 md:pb-16 px-4 md:px-8 overflow-hidden bg-brand-dark" data-id="element-102" data-mp="23vcqy7zvgd2r">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-brand-anthracite via-brand-dark to-brand-dark -z-10" data-id="element-103" data-mp="1yy4ix08ftpf8" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[420px] bg-brand-gold/5 blur-[120px] rounded-full -z-10" data-id="element-104" data-mp="2rlqky420olzz" />

      <div className="max-w-6xl mx-auto grid gap-8 md:gap-12 md:grid-cols-[1.05fr_0.95fr] md:items-center" data-id="element-105" data-mp="2mtyurumrwiad">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center md:text-left" data-id="element-106" data-mp="2hv5qmstdm3mv">
          <p className="text-[10px] md:text-xs font-medium tracking-[0.22em] text-brand-gold uppercase mb-4" data-id="element-107" data-mp="17tx4yvg4kwnn">
            Archivo digital · 6 tomos + 3 investigaciones
          </p>

          <h1 className="font-serif text-[28px] leading-[1.15] md:text-5xl font-bold text-white mb-4" data-id="element-108" data-mp="y1hok2kh8g4v">
            Casos, documentos y testimonios que dejaron demasiadas preguntas
            abiertas.
          </h1>

          <p className="text-sm md:text-lg text-brand-muted leading-relaxed mb-5 max-w-xl mx-auto md:mx-0" data-id="element-109" data-mp="p3frtz7s09ne">
            Nos Mienten reúne fenómenos UAP/OVNI, archivos históricos,
            encuentros documentados, civilizaciones perdidas y episodios
            difíciles de ignorar en una colección digital creada para explorar,
            comparar y sacar tus propias conclusiones.
          </p>

          <p className="font-serif text-base md:text-xl text-brand-offWhite border-l-2 border-brand-gold pl-4 text-left mb-7 max-w-md mx-auto md:mx-0" data-id="element-110" data-mp="29f3p0jvse45p">
            No necesitas creer. Solo necesitas querer mirar.
          </p>

          <Button fullWidth onClick={() => scrollToId('incluye')} className="md:w-auto md:px-10 text-base py-4" data-id="element-111" data-mp="27z7xj059dxff">
            VER QUÉ HAY DENTRO
          </Button>

          <p className="text-[11px] md:text-xs text-brand-muted mt-4 leading-relaxed" data-id="element-112" data-mp="1y2d3atg0qj6y">
            Acceso inmediato · Formato digital · Lectura en celular, tablet o PC
            · Pago único
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative order-first md:order-none" data-id="element-113" data-mp="2qqqzr4rgl7ge">
          <img src="https://cdn.magicpatterns.com/uploads/g9b2hwXCqjNA6SvEzeo6ts/ChatGPT_Image_26_jun_2026,_18_39_00.png" alt="Colección digital Nos Mienten: archivo con 6 tomos y 3 investigaciones" className="w-full max-w-[300px] md:max-w-none h-auto mx-auto rounded-lg shadow-2xl border border-brand-card" data-id="element-114" data-mp="39o1xgkxfzstq" />
        </motion.div>
      </div>
    </section>;
}
const stanceBullets = ['Sin dogmas.', 'Sin conclusiones impuestas.', 'Sin teorías disfrazadas de certezas.', 'Solo un archivo para explorar preguntas que siguen abiertas.'];
export function EditorialStance() {
  return <Section data-id="element-115" data-mp="8qptkl6aac9v">
      <div className="max-w-3xl mx-auto" data-id="element-116" data-mp="djizvdhehso2">
        <h2 className="font-serif text-2xl md:text-4xl font-bold text-white mb-4 text-center" data-id="element-117" data-mp="dkkd9olw2r8y">
          No es un libro para decirte qué creer.
        </h2>
        <p className="text-sm md:text-lg text-brand-muted leading-relaxed text-center mb-8" data-id="element-118" data-mp="nhp1dtzaowse">
          Nos Mienten no intenta venderte una verdad absoluta. Reúne casos,
          documentos, testimonios, cronologías e hipótesis para que puedas
          recorrer el material y formar tu propia mirada.
        </p>
        <ul className="grid gap-2 sm:grid-cols-2 max-w-2xl mx-auto" data-id="element-119" data-mp="1k9damhuihcb4">
          {stanceBullets.map(item => <li key={item} className="flex items-start gap-3 text-sm text-brand-offWhite border-t border-brand-card pt-3" data-id="element-120" data-mp="1yy9j2g0hcrc9">
              <Minus className="w-4 h-4 text-brand-gold shrink-0 mt-0.5" data-id="element-121" data-mp="1u19e68fd9umq" />
              <span data-id="element-122" data-mp="169krp8p880dp">{item}</span>
            </li>)}
        </ul>
      </div>
    </Section>;
}
const fragments = ['Roswell.', 'Área 51.', 'Pilotos militares.', 'Objetos no identificados.', 'Civilizaciones perdidas.', 'Documentos desclasificados.', 'Testimonios que se repiten con patrones inquietantes.'];
export function Mystery() {
  return <Section darker data-id="element-123" data-mp="2qo4l9d9fsbic">
      <div className="max-w-3xl mx-auto text-center" data-id="element-124" data-mp="2qnl43yrm1r5d">
        <h2 className="font-serif text-2xl md:text-4xl font-bold text-white mb-6" data-id="element-125" data-mp="2mo3vwxksufwi">
          Algunas historias nunca terminaron de cerrar.
        </h2>

        <ul className="flex flex-wrap justify-center gap-x-3 gap-y-1.5 font-serif text-base md:text-2xl text-brand-offWhite mb-6" data-id="element-126" data-mp="2u5scb5mn33pt">
          {fragments.map(item => <li key={item} data-id="element-127" data-mp="2ka7dthgs4lkt">{item}</li>)}
        </ul>

        <p className="text-sm md:text-lg text-brand-muted leading-relaxed mb-8 max-w-2xl mx-auto" data-id="element-128" data-mp="2p7qpc9m3ek92">
          Casi siempre vimos estas piezas por separado. Este archivo las reúne
          dentro de un mismo recorrido.
        </p>

        <Button variant="outline" onClick={() => scrollToId('tomos')} data-id="element-129" data-mp="3hvmlnd7r2a5b">
          EXPLORAR EL ARCHIVO
        </Button>
      </div>
    </Section>;
}